import React from 'react';
import { Box, Link, Typography } from "@mui/material"
import { useAuth0 } from '@auth0/auth0-react';


const Index = () => {
    const { logout } = useAuth0();
    return (
        <Box sx={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant='h3'>Unauthorized</Typography>
            <Typography variant='h6'>You don't have access to view this application.</Typography>
            <Link mt={3} sx={{cursor:'pointer'}} onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>Logout</Link>

        </Box>
    )
}

export default Index;